<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
      <div class="row align-items-center" style="height: 4em;">
  <!-- Left: Page title -->
  <div class="col-md-6">
    <p class="appTitle mb-0">Add Videos</p>
  </div>

  <!-- Right: Admin name + avatar -->
  <div class="col-md-6 d-flex justify-content-end align-items-center">
    <p class="adminName mb-0 mr-2">{{ adminName }}</p>
    <img width="36px" height="36px"  src="assets/tenant-avatar.jpg" class="rounded-circle" />
  </div>
</div>

        <!-- Search + Add -->
        <div class="row my-4">
          <div class="col">
            <div class="container-fluid">
              <div class="row align-items-center">
                <!-- Modern Searchbar -->
                <div class="col-md-4 searchCol">
                  <div class="modern-search">
                    <i class="fa fa-search search-left"></i>

                   <input
  type="text"
  class="modern-search-input"
  placeholder="Search videos, college name or URL..."
  [(ngModel)]="searchval"
  (input)="onQuickFilterChanged()"
/>
<button *ngIf="searchval" class="modern-clear" (click)="clearSearch()">✕</button>
                  </div>
                </div>

                <!-- Add Video Button -->
                <div class="col-md-2 ml-auto text-right">
                  <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
                    <i class="fa fa-plus" aria-hidden="true"></i> Add Video
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- AG Grid -->
        <div class="tableView" *ngIf="showData">
       <ag-grid-angular
  #agGrid
  class="ag-theme-alpine modern-grid"
  style="width: 100%; height: 600px;"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  (gridReady)="onGridReady($event)"
  (cellClicked)="onCellClicked($event)"
  [pagination]="true"
  [paginationPageSize]="10"
  [rowHeight]="45" 
  [getRowStyle]="getRowStyle"
>
</ag-grid-angular>

        </div>

        <!-- No Data -->
        <div class="noData" *ngIf="showNodata">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <div class="backdrop" [ngStyle]="{'display': display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display': display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">

            <!-- Header with X on right -->
            <div class="modal-header d-flex justify-content-between align-items-center">
              <div class="modal-title">
                <span *ngIf="showAdd">Add Video</span>
                <span *ngIf="showEdit">Edit Video</span>
              </div>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="videoForm" (ngSubmit)="$event.preventDefault()">

                <!-- avatar + camera overlay -->
                <div class="text-center mb-3">
                  <div class="position-relative d-inline-block">
                    <img
                      width="80px"
                      height="80px"
                      *ngIf="imageUrl"
                      [src]="imageUrl"
                      class="rounded-circle"
                      alt="avatar"
                    />
                    <!-- camera icon overlay (bottom right) -->
                    <label class="camera-icon" style="position: absolute; bottom: -4px; right: -4px; cursor: pointer;">
                      <i class="fa fa-camera"></i>
                      <input
                        type="file"
                        formControlName="imageVal"
                        (change)="handleFileInput($event.target.files)"
                        hidden
                      />
                    </label>
                  </div>
                </div>

                <div class="error-messages">
                  <div *ngFor="let error of error_messages.imageVal">
                    <div
                      class="error-message"
                      *ngIf="videoForm.get('imageVal').hasError(error.type) && (videoForm.get('imageVal').dirty || videoForm.get('imageVal').touched)"
                    >
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <!-- College selector and Video URL -->
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>College</label>
                    <select class="form-control" [(ngModel)]="collegeId" formControlName="colgVal">
                      <option *ngFor="let college of colleges; let x = index" [ngValue]="college.id">
                        {{ college.collage_name }}
                      </option>
                    </select>

                    <div class="error-messages">
                      <div *ngFor="let error of error_messages.colgVal">
                        <div
                          class="error-message"
                          *ngIf="videoForm.get('colgVal').hasError(error.type) && (videoForm.get('colgVal').dirty || videoForm.get('colgVal').touched)"
                        >
                          {{ error.message }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-md-12">
                    <label>Video URL</label>
                    <input class="form-control" [(ngModel)]="videoUrl" formControlName="videoVal" />

                    <div class="error-messages">
                      <div *ngFor="let error of error_messages.videoVal">
                        <div
                          class="error-message"
                          *ngIf="videoForm.get('videoVal').hasError(error.type) && (videoForm.get('videoVal').dirty || videoForm.get('videoVal').touched)"
                        >
                          {{ error.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="addBtn d-flex justify-content-center mt-3">
                  <button
                    *ngIf="showAdd"
                    class="commonBtn"
                    [disabled]="!videoForm.valid"
                    (click)="addVideo()"
                    type="button"
                  >
                    Add Video
                  </button>

                  <button
                    *ngIf="showEdit"
                    class="commonBtn"
                    [disabled]="!videoForm.valid"
                    (click)="updateVideo()"
                    type="button"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [ngStyle]="{'display': displayDelete}"></div>
      <div class="modal" id="deleteModel" tabindex="-1" role="dialog" [ngStyle]="{'display': displayDelete}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
              <p>Do you want to delete Degree ?</p>
              <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
              <button
                type="submit"
                class="btn btn-danger"
                (click)="onCloseHandled()"
                style="width: 20%; margin-left: 0.3em;"
              >
                No
              </button>
              <br /><br />
              <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
